// Permite configurar a base da API via variável de ambiente
// Em produção, defina VITE_API_BASE_URL conforme o caminho no servidor
// Ex.: VITE_API_BASE_URL=/api  OU  VITE_API_BASE_URL=/sistema/react/api
const API_BASE_URL = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_API_BASE_URL)
  ? import.meta.env.VITE_API_BASE_URL
  : '/api'

class ApiService {
  constructor() {
    this.baseURL = API_BASE_URL
  }

  async request(endpoint, options = {}) {
    // Montar URL absoluta corretamente
    const base = this.baseURL.endsWith('/') ? this.baseURL.slice(0, -1) : this.baseURL
    const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`
    const url = `${base}${path}`
    
    const defaultOptions = {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      credentials: 'include', // Incluir cookies de sessão
    }

    const config = {
      ...defaultOptions,
      ...options,
      headers: {
        ...defaultOptions.headers,
        ...options.headers,
      },
    }

    try {
      const response = await fetch(url, config)
      
      // Verificar se a resposta é JSON
      const contentType = response.headers.get('content-type')
      if (contentType && contentType.includes('application/json')) {
        const data = await response.json()

        if (response.status === 401) {
          return {
            ok: data.ok || false,
            data: data.data || null,
            message: data.message || 'Não autenticado',
            error: data.error || null,
            status: 401,
            ...data
          }
        }

        return {
          ok: data.ok || false,
          data: data.data || null,
          message: data.message || '',
          error: data.error || null,
          status: response.status,
          ...data
        }
      } else {
        // Se não for JSON, retornar erro
        return {
          ok: false,
          message: 'Resposta inválida do servidor',
          status: response.status
        }
      }
    } catch (error) {
      console.error('Erro na requisição:', error)
      return {
        ok: false,
        message: 'Erro de conexão',
        error: error.message,
        status: 0
      }
    }
  }

  async get(endpoint, params = {}) {
    const queryString = new URLSearchParams(params).toString()
    const url = queryString ? `${endpoint}?${queryString}` : endpoint
    
    return this.request(url, {
      method: 'GET',
    })
  }

  async post(endpoint, data = {}) {
    return this.request(endpoint, {
      method: 'POST',
      body: JSON.stringify(data),
    })
  }

  async put(endpoint, data = {}) {
    return this.request(endpoint, {
      method: 'PUT',
      body: JSON.stringify(data),
    })
  }

  async delete(endpoint) {
    return this.request(endpoint, {
      method: 'DELETE',
    })
  }
}

export const api = new ApiService()
